import SectionShell from "./SectionShell";
import FieldGroup from "./FieldGroup";
import ToggleSwitch from "../../Setting/components/printers/ToggleSwitch";
import { inputClass } from "./styles";

const PrintCategoriesSection = ({
  printCategories,
  isLoading,
  newPrintCategory,
  printCatErrors,
  onNewPrintCategoryChange,
  onAddPrintCategory,
  onTogglePrintCategory,
}) => {
  return (
    <SectionShell
      number="3"
      title="Print Categories"
      subtitle="Manage print categories ."
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="flex items-center justify-between mb-3">
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-widest">
              Available Print Categories
            </div>
            {isLoading ? (
              <div className="text-xs text-gray-500">Loading...</div>
            ) : null}
          </div>
          <div className="border border-gray-100 rounded-xl overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50">
                <tr className="text-left text-xs text-gray-500 uppercase tracking-widest">
                  <th className="px-4 py-3">Key</th>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {(printCategories || []).length === 0 ? (
                  <tr>
                    <td className="px-4 py-4 text-gray-500" colSpan={3}>
                      No print categories found.
                    </td>
                  </tr>
                ) : (
                  printCategories.map((c) => (
                    <tr key={c._id} className="bg-white">
                      <td className="px-4 py-3 font-semibold text-gray-900">
                        {c.key}
                      </td>
                      <td className="px-4 py-3 text-gray-700">{c.name}</td>
                      <td className="px-4 py-3 flex ">
                        <ToggleSwitch
                          checked={!!c.isActive}
                          onChange={() => onTogglePrintCategory(c._id)}
                          labelOn="Enabled"
                          labelOff="Disabled"
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div>
          <div className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-3">
            Add Print Category
          </div>
          <div className="space-y-4">
            <FieldGroup label="Name">
              <input
                className={`${inputClass} ${printCatErrors.name ? "border-red-500 focus:border-red-500" : ""}`}
                value={newPrintCategory.name}
                onChange={(e) => onNewPrintCategoryChange("name", e.target.value)}
                placeholder="Kitchen"
              />
              {printCatErrors.name && (
                <p className="text-xs text-red-500 mt-1">{printCatErrors.name}</p>
              )}
            </FieldGroup>
            <FieldGroup label="Key (unique)">
              <input
                className={`${inputClass} ${printCatErrors.key ? "border-red-500 focus:border-red-500" : ""}`}
                value={newPrintCategory.key}
                onChange={(e) => onNewPrintCategoryChange("key", e.target.value)}
                placeholder="kitchen"
              />
              {printCatErrors.key && (
                <p className="text-xs text-red-500 mt-1">{printCatErrors.key}</p>
              )}
            </FieldGroup>
            <button
              type="button"
              onClick={onAddPrintCategory}
              className="w-full bg-black hover:bg-gray-900 text-white px-4 py-2.5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200"
            >
              Add Category
            </button>
          </div>
        </div>
      </div>
    </SectionShell>
  );
};

export default PrintCategoriesSection;
